import { authSplitApi } from 'redux/helpers/slice.helpers';
import { ELeasePacketUrls } from 'data/urls/leasePacket.url';
import {
  TLeasePacketDB,
  TLeasePacketUI,
  TValidateLeasePacketCodeUI,
} from 'data/types/leasePacket.types';
import {
  leasePacketDataConverter,
  validateLeasePacketCodeConvertor,
} from 'data/convertors/leasePacket.convertors';

export const leasePacketApi = authSplitApi('leasePacket').injectEndpoints({
  endpoints: build => ({
    validateLeasePacketCode: build.mutation<
      TLeasePacketUI,
      TValidateLeasePacketCodeUI
    >({
      query(body) {
        return {
          url: `${ELeasePacketUrls.ACCESS_CODE}`,
          method: 'GET',
          params: validateLeasePacketCodeConvertor.toDb(body),
        };
      },
      invalidatesTags: [],
      transformResponse: (data: TLeasePacketDB) =>
        leasePacketDataConverter.fromDb(data),
    }),
  }),
});

export const { useValidateLeasePacketCodeMutation } = leasePacketApi;
